import { render, staticRenderFns } from "./SectionTitleBar.vue?vue&type=template&id=536158e8&"
import script from "./SectionTitleBar.vue?vue&type=script&lang=js&"
export * from "./SectionTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitleBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports